module.exports = __webpack_public_path__ + "static/media/site-rse.b608c8c1.glb";